import { Link } from "react-router-dom"
import dayjs from "dayjs"
import { JoinedOperation } from "./JoinedOperation"
import { isCreatedInTwoDays } from "./isCreatedInTwoDays"
import { composeUnreportedWarning } from "./composeUnreportedWarning"
import { CleaningItem } from "@/parts/CleaningItem/CleaningItem"

// 通常清掃かオペレーションかを判定する。広義のオペレーション(統合後)のことを指しているわけではない
const isOperation = (op: JoinedOperation) => {
    // photoTourIdがあってもphotoTour自体が見つからないケースが発生することがあったため、
    // photoTourIdで判定している
    return Boolean(op.photoTourId)
}

type TranslateFunction = (
    text: string,
    options?: { params?: Record<string, string | number> }
) => string

export type TimelineItemProps = JoinedOperation & {
    t: TranslateFunction
}

// NOTE: このコンポーネントはmatsuri-uiのTimelineのrenderItemとして使用される。
// TimelineはrenderItemを関数として直接呼び出すため（Reactコンポーネントとしてではなく）、
// React hooksを使用するとhooksのルールに違反してエラーが発生する。
// そのため、useTranslationは使用せず、t関数をpropsとして受け取る。
export const TimelineItem = (props: TimelineItemProps) => {
    const { t, ...operation } = props
    const {
        operationId,
        cleaningDate,
        cleaningStatus,
        scheduleStart,
        scheduleEnd,
        placementName,
        hasCheckin,
        hasErrands,
        photoTour,
        createdAt,
        deadlineAt,
        occupancy
    } = operation

    const unreportedWarning =
        cleaningStatus !== "prepared"
            ? composeUnreportedWarning(cleaningDate)
            : undefined

    const isNew =
        cleaningStatus === "prepared" &&
        // 直近2日以内に作成されたものは新着とみなす
        isCreatedInTwoDays(createdAt, dayjs())

    const linkUrl = isOperation(operation)
        ? `/operations/${operationId}`
        : `/cleanings/${operationId}`

    const durationMinutes =
        scheduleStart && scheduleEnd
            ? dayjs.unix(scheduleEnd).diff(dayjs.unix(scheduleStart), "minutes")
            : undefined

    const scheduleText =
        scheduleStart && scheduleEnd
            ? dayjs.unix(scheduleStart).format("HH:mm") +
              " - " +
              dayjs.unix(scheduleEnd).format("HH:mm") +
              ` ${t("({{minutes}}分)", { params: { minutes: durationMinutes! } })}`
            : undefined

    const deadlineText = deadlineAt
        ? t("終了期限 〜{{time}}", {
              params: { time: dayjs.unix(deadlineAt).format("HH:mm") }
          })
        : undefined
    return (
        <Link key={operationId} to={linkUrl}>
            <CleaningItem
                text={placementName}
                imageUrl={""}
                status={cleaningStatus}
                isNew={isNew}
                checkinAvailable={hasCheckin}
                guestStayStatus={occupancy?.guest}
                hasEarlyCheckin={occupancy?.hasEarlyCheckin}
                requestAvailable={hasErrands}
                cleaningType={photoTour ? photoTour.title : undefined}
                unreportedWarning={
                    unreportedWarning ? t(unreportedWarning) : undefined
                }
                isImportant={dayjs(cleaningDate).isSame(dayjs(), "day")}
                scheduleText={scheduleText}
                deadlineText={deadlineText}
            />
        </Link>
    )
}
